// extracted by mini-css-extract-plugin
export default {"Box_0":"StyledInput-module__Box_0--wGp5d","Box_1":"StyledInput-module__Box_1--WBhEL","Box_2":"StyledInput-module__Box_2--h5s9e","KeyBlock_0":"StyledInput-module__KeyBlock_0--Ucg7o"};